import { createStateContext } from '@change-corgi/core-react/context';

import { initialState } from './initialState';
import { mutations } from './mutations';
import type { PsfPromoteOrSharePageState } from './types';

// Source of truth for page-level CTA behavior. PromoteForm keeps its own local state
// and synchronizes with this context when mounted.
/** @knip-ignore */
export const {
	StateContext: PsfPromoteOrSharePageStateContext,
	StateProvider: PsfPromoteOrSharePageStateContextProvider,
	useStateContext: usePsfPromoteOrSharePageState,
} = createStateContext<PsfPromoteOrSharePageState, typeof mutations>({
	name: 'PsfPromoteOrSharePageStateContext',
	mutations,
	initialState: initialState(),
});
